import { useEffect, useState } from "react";

import { LAYOUT_BREAKPOINTS } from "@configs/breakpoints";

export type LayoutBreakpoint = keyof typeof LAYOUT_BREAKPOINTS;

export interface LayoutBreakpointScreens {
	MAX_DESKTOP: boolean;
	DESKTOP: boolean;
	TABLET: boolean;
	MOBILE: boolean;
	MOBILE_SMALL: boolean;
	SHORT_VIEWPORT: boolean;
	COMPACT_GOALS: boolean;
}

const getLayoutScreens = (): LayoutBreakpointScreens => {
	if (typeof window === "undefined" || !window.matchMedia) {
		return {
			MAX_DESKTOP: true,
			DESKTOP: true,
			TABLET: true,
			MOBILE: true,
			MOBILE_SMALL: true,
			SHORT_VIEWPORT: false,
			COMPACT_GOALS: false,
		};
	}
	return {
		MAX_DESKTOP: window.matchMedia(LAYOUT_BREAKPOINTS.MAX_DESKTOP).matches,
		DESKTOP: window.matchMedia(LAYOUT_BREAKPOINTS.DESKTOP).matches,
		TABLET: window.matchMedia(LAYOUT_BREAKPOINTS.TABLET).matches,
		MOBILE: window.matchMedia(LAYOUT_BREAKPOINTS.MOBILE).matches,
		MOBILE_SMALL: window.matchMedia(LAYOUT_BREAKPOINTS.MOBILE_SMALL).matches,
		SHORT_VIEWPORT: window.matchMedia(LAYOUT_BREAKPOINTS.SHORT_VIEWPORT).matches,
		COMPACT_GOALS: window.matchMedia(LAYOUT_BREAKPOINTS.COMPACT_GOALS).matches,
	};
};

export const useLayoutBreakpoint = (): LayoutBreakpointScreens => {
	const [screens, setScreens] = useState<LayoutBreakpointScreens>(getLayoutScreens);

	useEffect(() => {
		const entries = (Object.keys(LAYOUT_BREAKPOINTS) as LayoutBreakpoint[]).map((key) => ({
			key,
			mql: window.matchMedia(LAYOUT_BREAKPOINTS[key]),
		}));

		const listener = () => setScreens(getLayoutScreens());

		entries.forEach(({ mql }) => mql.addEventListener("change", listener));
		listener();

		return () => entries.forEach(({ mql }) => mql.removeEventListener("change", listener));
	}, []);

	return screens;
};
